import BaseRequestService from "./base-request-service";

class wishlist extends BaseRequestService {
    getWishlist = query => this.getRequest('api/wishlist/by-list', query)
}

export default new wishlist();